<div class="checkin-card">
  <div class="checkin-top">
    <span class="checkin-badge">{{ selo }}</span>

    <div class="checkin-tickets">
      <span class="checkin-tickets-number">{{ bilhetes }}</span>
      <span class="checkin-tickets-label">bilhetes</span>
    </div>
  </div>

  <h2 class="checkin-title">Check-in diário</h2>
  <p class="checkin-subtitle">Faça check-in e ganhe 1 bilhete para a Raspadinha Premiada.</p>

  <div class="checkin-streak-header">
    <span class="checkin-streak-label">Sua sequência</span>
    <span class="checkin-streak-status">
      {{ diasConsecutivos }}/{{ totalDias }} @if(faltamParaBonus > 0) { &nbsp;·&nbsp;faltam {{ faltamParaBonus }} para +{{ pontosBonus }} pts }
    </span>
  </div>

  <div class="checkin-days">
    @for(item of diasSequencia; track item.dia) {
    <div class="checkin-day">
      <div class="checkin-day-circle" [ngClass]="'is-' + item.status">
        @if(item.status === 'done') {
        <ion-icon name="checkmark-outline"></ion-icon>
        } @else {
        <span>{{ item.dia }}</span>
        }
      </div>
      <span class="checkin-day-label">Dia {{ item.dia }}</span>
      @if(item.dia === totalDias) {
      <span class="checkin-day-bonus">+{{ pontosBonus }} pts</span>
      }
    </div>
    }
  </div>

  @if(!checkInFeitoHoje) {
  <ion-button class="checkin-btn-primary" expand="block" [disabled]="requestInProgress" (click)="onTouchCheckIn()">
    @if(requestInProgress) {
    <ion-spinner name="dots" color="dark"></ion-spinner>
    } @else { Fazer check-in de hoje }
  </ion-button>
  } @else {
  <div class="checkin-done-notice">
    <ion-icon name="checkmark-outline"></ion-icon>
    Check-in de hoje feito! Volte amanhã.
  </div>

  <ion-button class="checkin-btn-scratch" expand="block" (click)="onTouchJogarRaspadinha()">Jogar Raspadinha</ion-button>
  }

  <div class="checkin-prize-info">
    <ion-icon name="phone-portrait-outline"></ion-icon>
    <p>
      São mais de 1.000 prêmios, incluindo um
      <strong>{{ premioDestaque }}</strong>
      .
    </p>
  </div>

  <p class="checkin-buy-ticket">
    Sem bilhetes?
    <a (click)="onTouchComprarBilhete()">Compre 1 por {{ custoBilhetePontos }} pts</a>
  </p>
</div>

<ion-modal [isOpen]="isOpenComprarBilhete" cssClass="checkin-modal-buy" (didDismiss)="isOpenComprarBilhete = false">
  <ng-template>
    <div class="checkin-card checkin-modal-content">
      <span class="checkin-badge checkin-modal-badge">{{ selo }}</span>

      <h2 class="checkin-title checkin-modal-title">Comprar bilhete</h2>

      <div class="checkin-modal-summary">
        <span class="checkin-modal-summary-value">1 bilhete = {{ custoBilhetePontos }} pts</span>
        <span class="checkin-modal-summary-balance">Seu saldo: {{ saldoPontos }} pts</span>
      </div>

      <ion-button class="checkin-btn-primary" expand="block" (click)="onTouchConfirmarCompra()">Confirmar compra</ion-button>

      <p class="checkin-modal-cancel" (click)="onTouchCancelarCompra()">Cancelar</p>
    </div>
  </ng-template>
</ion-modal>

<ion-modal [isOpen]="isOpenSequenciaCompleta" cssClass="checkin-modal-buy" (didDismiss)="isOpenSequenciaCompleta = false">
  <ng-template>
    <div class="checkin-card checkin-modal-content">
      <span class="checkin-badge checkin-modal-badge">{{ selo }}</span>

      <h2 class="checkin-title checkin-modal-title">Sequência completa!</h2>
      <p class="checkin-modal-streak-subtitle">{{ totalDias }} check-ins seguidos</p>

      <div class="checkin-modal-summary">
        <span class="checkin-modal-summary-value">+{{ pontosBonus }} pts</span>
      </div>

      <ion-button class="checkin-btn-primary" expand="block" (click)="onTouchContinuarSequenciaCompleta()">Continuar</ion-button>
    </div>
  </ng-template>
</ion-modal>
